import React, { createContext, useContext, useState, ReactNode } from 'react';

type LegalModalType = 'privacy' | 'cookies' | 'legal' | 'terms' | null;

interface LegalModalContextType {
  isOpen: boolean;
  modalType: LegalModalType;
  openModal: (type: LegalModalType) => void;
  closeModal: () => void;
}

const LegalModalContext = createContext<LegalModalContextType | undefined>(undefined);

interface LegalModalProviderProps {
  children: ReactNode;
}

export const LegalModalProvider: React.FC<LegalModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState<LegalModalType>(null);

  const openModal = (type: LegalModalType) => {
    setModalType(type);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalType(null);
  };

  const value: LegalModalContextType = {
    isOpen,
    modalType,
    openModal,
    closeModal,
  };

  return (
    <LegalModalContext.Provider value={value}>
      {children}
    </LegalModalContext.Provider>
  );
};

export const useLegalModal = (): LegalModalContextType => {
  const context = useContext(LegalModalContext);
  if (!context) {
    throw new Error('useLegalModal must be used within a LegalModalProvider');
  }
  return context;
};